define('controllers/myreport/myreport-theme.ctrl',['app','mainCons'], function (app,mainCons) {
    app.controller('themeReport', ['$scope', '$q', 'OpenApp', 'OpenOther','auiDialog','OpenUp','BalanceApp','ngDialog','UserInfo',
        function ($scope, $q, OpenApp, OpenOther,auiDialog,OpenUp,BalanceApp,ngDialog,UserInfo) {
    	    var currentSubPage = "";
            /* 1. 局部变量声明 */
            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                queryThemeApps: {
                	 appId: '-1',                  //【产品下拉框】【默认值】-1,
                     isTheme: true,
                     appListQueryMethod: $scope.$parent.initAppList('theme', 30),
                     regionShow: [0, 2, 3, 4, 5, 6],       //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                     regionType: 2,               //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                     startTime: new Date(),       //【开始时间】【默认值】今天
                     endTime: new Date(),         //【结束时间】【默认值】今天
                     timeQuantum:31,              //【允许的时间跨度】默认值是不限制
                     queryMethod: queryList,
                     downloadMethod: downloadList,
                     onload:init
                },
                queryThemeAppsList:[],
                queryThemesForTable: null,
                paginationMessage: {
                    currentPage: 1, itemsPerPage: 10,  itemsPerPageBackUp: 10, totalCount: 0, noItems: "No products", pagesLength: 5, onChange: pageChangeMessage
                }

            };

            function init() {
            	queryList();
            }


            // 获取报表数据
            function queryList(){
            	 // 请求参数
            	 var request = {
                         appId:Model.queryThemeApps.appId != '-1' ? Model.queryThemeApps.appId : '',
                         startTime:Model.queryThemeApps.startTime,
                         endTime:Model.queryThemeApps.endTime,
                         pageNum:1,
                         pageSize: 100000
                     };
                     // 查询主题报表数据
                if(!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }
                     OpenOther.openThemeMessageGet(request).then(function (resp) {
                         Model.queryThemeAppsList = resp.themeInfoList;
                         Model.paginationMessage.totalCount = resp.total;
                         Model.paginationMessage.currentPage = 1;
                         Model.paginationMessage.itemsPerPage= Model.paginationMessage.itemsPerPageBackUp;
                         pageChangeMessage();
                     });
            }

            function downloadList() {
            	 var request = {appId:Model.queryThemeApps.appId != '-1' ? Model.queryThemeApps.appId  : '', startTime:Model.queryThemeApps.startTime, endTime:Model.queryThemeApps.endTime, pageNum:1, pageSize: 100000};
                if(!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误","查询时间不能为空");
                    return;
                }
            	 OpenOther.openThemeMessageGet(request).then(function (resp) {
                     Model.queryThemeAppsList = resp.themeInfoList;
                     var param = {
                             startTime : Model.queryThemeApps.startTime,
                             endTime: Model.queryThemeApps.endTime,
                             appId:Model.queryThemeApps.appId != '-1' ? Model.queryThemeApps.appId  : '',
                             pageNum:1,
                             pageSize: 100000,
                             type:30
                         };

                         $scope.$parent.downloadReport(OpenOther.exportReportThemeBI,param,function(resp){
                             return resp && resp.retCode == 0;
                         });
                 });
            }

            function pageChangeMessage() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.queryThemeAppsList, Model.paginationMessage));
                if(result.listForShow.length > 0){
                	result.listForShow = result.listForShow.reverse();
                }
                Model.queryThemesForTable = result.listForShow;
            }


        }]
    );
});
